import styled from 'styled-components';

import {colors, font, breakpoint} from 'theme';

export const Root = styled.form`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const Grid = styled.div<{columns: string}>`
    display: grid;
    grid-template-columns: ${(p) => p.columns};
    grid-auto-rows: auto;
    gap: 10px;
    width: 100%;
    height: 100%;
    @media (max-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr;
    }
`;

export const Headline = styled.div`
    margin-bottom: 10px;
    padding-left: 2px;
    color: ${colors.black};
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
`;
